var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgendaItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5583 16.7333C10.8808 17.4108 10.5 18.3292 10.5 19.2875V20.5H11.7125C12.6708 20.5 13.5892 20.1192 14.2667 19.4417L19.9392 13.7692C20.6867 13.0217 20.6867 11.8083 19.9392 11.0608C19.1917 10.3133 17.9783 10.3133 17.2308 11.0608L11.5583 16.7333ZM20.5 7.16667H0.5V6.33333C0.5 4.03583 2.36917 2.16667 4.66667 2.16667H5.5V1.33333C5.5 0.873333 5.8725 0.5 6.33333 0.5C6.79417 0.5 7.16667 0.873333 7.16667 1.33333V2.16667H13.8333V1.33333C13.8333 0.873333 14.2058 0.5 14.6667 0.5C15.1275 0.5 15.5 0.873333 15.5 1.33333V2.16667H16.3333C18.6308 2.16667 20.5 4.03583 20.5 6.33333V7.16667ZM0.5 8.83333H18.2975C17.5983 8.9175 16.9083 9.235 16.3042 9.83917L10.2983 15.845C9.35333 16.7892 8.83333 18.045 8.83333 19.3808V20.5H4.66667C2.36583 20.5 0.5 18.6342 0.5 16.3333V8.83333Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaItem);
export default __webpack_public_path__ + "static/media/agenda-item.5a82be2ec5d927a8a93982b7a45f52f9.svg";
export { ForwardRef as ReactComponent };